import React from "react";
import { Link } from "react-router-dom";

const UpperNav = () => (
  <div className="upper-nav">
    <div className="site-shell upper-nav-inner">
      <Link to="/" aria-label="Visiosol home"><img src="/logo.png" alt="Visiosol" className="brand-logo" /></Link>
      <div className="upper-contact">
        <span>AI · Agents · Data · Engineering</span>
        <a className="header-contact-link" href="mailto:info@visiosol.tech">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.75 5.75h16.5v12.5H3.75z"/><path d="m4.5 7 7.5 6 7.5-6"/></svg>
          info@visiosol.tech
        </a>
        <a className="header-contact-link header-whatsapp" href="https://wa.me/923335274666?text=Hello%20Visiosol%2C%20I%27d%20like%20to%20discuss%20a%20project%20with%20your%20team." target="_blank" rel="noreferrer">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 11.7a8.5 8.5 0 0 1-12.6 7.45L3.5 20.5l1.42-4.24A8.5 8.5 0 1 1 20.5 11.7Z"/><path d="M8.2 7.55c.2-.45.42-.46.74-.47h.63c.2 0 .42.08.52.34l.72 1.72c.08.24.04.43-.1.62l-.54.66c-.16.18-.13.35-.02.55.64 1.12 1.52 2 2.67 2.64.2.11.38.12.55-.07l.72-.84c.17-.2.37-.24.6-.15l1.65.78c.25.12.41.18.46.29.06.11.06.65-.13 1.22-.2.57-1.15 1.09-1.58 1.15-.42.06-.96.09-1.55-.1-.36-.12-.83-.27-1.43-.53a12.2 12.2 0 0 1-4.7-4.15c-.6-.82-1.22-1.85-1.22-2.95 0-1.1.57-1.64.78-1.85Z"/></svg>
          WhatsApp
        </a>
      </div>
    </div>
  </div>
);
export default UpperNav;
